import { createContext } from "react";
import BetDetailsStore from "@state/stores/my-bets/BetDetailsStore";
import MyBetsStore from "@state/stores/my-bets/MyBetsStore";
import { BetSlipShareDetails } from "@state/stores/my-bets/BetSlipShareDetailsStore";

export const MyBetsStoreContext = createContext<
	MyBetsStore | BetDetailsStore | BetSlipShareDetails | null
>(null);
